import React from 'react';
import {Link} from 'react-router-dom';

import * as S from './NoStreamTableMessage.styles';

export const NoStreamTableMessage = () => {
  return (
    <S.Container>
      <S.EmptyTitle>This queue has not been used yet.</S.EmptyTitle>
      <S.EmptyMessage>
        Metrics will appear here after enqueuing at least one job. Check the{' '}
        <Link to="https://docs.wandb.ai/guides/launch/add-job-to-queue">
          launch docs
        </Link>{' '}
        for more info.
      </S.EmptyMessage>
    </S.Container>
  );
};
